import { Resources } from 'constants/resources';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { Button } from 'shared/mui/Buttons';

type Props = {
  requestId?: string;
  setIsFormSubmitted: (v: boolean) => void;
};

export const OrderAdjustmentsFormAlertSuccess: React.FC<Props> = ({
  requestId,
  setIsFormSubmitted,
}) => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <Alert
      action={[
        requestId && (
          <Button
            color="inherit"
            component={Link}
            key="report-button"
            label={translate('app.orderAdjustments.header.goToReport')}
            size="small"
            sx={{ marginRight: '16px' }}
            target="_blank"
            to={createPathWithQuery(
              {
                resource: Resources.OrderAdjustmentsReport,
                type: 'list',
              },
              { filter: { requestId } },
            )}
          />
        ),
        <IconButton
          color="inherit"
          key="close-button"
          onClick={() => setIsFormSubmitted(false)}
          size="small"
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>,
      ]}
      onClose={() => setIsFormSubmitted(false)}
      sx={{ mt: '24px', '& .MuiAlert-message': { flex: 1 } }}
      title={translate('app.orderAdjustments.header.submitSuccess')}
    >
      {translate('app.orderAdjustments.header.submitInfo')}
    </Alert>
  );
};
